import { ProductPage } from "@/views/productPage"
import SipjoyAppContext from "@/src/contexts/SipjoyAppContext"

const productPage = ({pageData, siteContext}) => {
  const brand = pageData?.product?.brand;
  let topBarLogo, topBarLogoUrl
  if (brand) {
    topBarLogo = brand.template?.top_bar_logo?.src
    topBarLogoUrl = makeBrandUrl({ slug: brand.slug, locRef: 'header' })
  }
  const page_template = pageData?.product?.page_template
  if (page_template?.theme) {
    siteContext.site.theme = page_template.theme
  }
  return (
    <SipjoyAppContext
      siteContext={siteContext}
      topBarLogo={topBarLogo}
      topBarLogoUrl={topBarLogoUrl}
    >
      <ProductPage pageData={pageData} />
    </SipjoyAppContext>
  )
}

export default productPage

import { getAllProductsFromService, getProductFromService } from "@/src/services/sipjoyService"
import { generateSiteProperties } from "@/src/contexts/SiteContext"
import { makeBrandUrl } from "@/src/utils/urlGenerator";
import { omitUndefined } from "@/src/utils/objectUtils";

export async function getStaticProps({ params }) {
  let { siteKey, slug } = params;
  let pageData = {};
  let siteContext = null;
  if (!siteKey || !slug) {
    console.error('siteKey and slug are mandatory')
    return { props: {}};
  }
  try {

    siteContext = siteKey && await generateSiteProperties(siteKey)
    if (siteContext) {
      siteContext = JSON.parse(JSON.stringify(siteContext))
    } else {
      siteContext = null;
    }
    siteContext = omitUndefined(siteContext)

    const product = await getProductFromService({siteKey, slug})
    pageData = JSON.parse( JSON.stringify({product}));
  } catch (err) {
    console.error(`error while building static product page '${slug}`, err)
  }
  return {
    revalidate: 60, // 1 minute
    props: { pageData, siteContext }, 
  }
}

export async function getStaticPaths() {
  let productsToLoad = [];
  try {

    const allProducts = await getAllProductsFromService();
    productsToLoad = allProducts
      ? allProducts.map((p) => ({ siteKey: p.site, slug: p.slug }))
      : []
  } catch (err) {
    console.error('error while building static products page', err)
  }
    
  return {
    paths: productsToLoad.map(p => ({params: p})),
    fallback: true
  };
}